import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getMoviesApiUrl,
  getUnavailableApiMessage,
  parseJsonResponse,
} from '../../../lib/moviesAdminApi';
import { MOVIES_ADMIN_ROUTE } from '../constants';

export const useMoviesAdminAccess = () => {
  const navigate = useNavigate();
  const [isAdminAccessModalOpen, setIsAdminAccessModalOpen] = useState(false);
  const [adminSecret, setAdminSecret] = useState('');
  const [adminAccessStatus, setAdminAccessStatus] = useState('idle');
  const [adminAccessMessage, setAdminAccessMessage] = useState('');

  const resetAccessState = () => {
    setAdminSecret('');
    setAdminAccessStatus('idle');
    setAdminAccessMessage('');
  };

  const handleOpenAdminAccessModal = () => {
    resetAccessState();
    setIsAdminAccessModalOpen(true);
  };

  const handleCloseAdminAccessModal = () => {
    setIsAdminAccessModalOpen(false);
    resetAccessState();
  };

  const handleAdminAccessSubmit = async (event) => {
    event.preventDefault();

    if (adminAccessStatus === 'authenticating') {
      return;
    }

    if (!adminSecret.trim()) {
      setAdminAccessMessage('Digite a credencial administrativa para continuar.');
      return;
    }

    setAdminAccessStatus('authenticating');
    setAdminAccessMessage('');

    try {
      const response = await fetch(getMoviesApiUrl('/api/movies/session'), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ secret: adminSecret.trim() }),
      });
      const data = await parseJsonResponse(response);

      if (response.status === 404) {
        setAdminAccessStatus('error');
        setAdminAccessMessage(getUnavailableApiMessage());
        return;
      }

      if (!response.ok) {
        setAdminAccessStatus('error');
        setAdminAccessMessage(
          data?.error || 'Nao foi possivel autenticar a sessao administrativa.'
        );
        return;
      }

      handleCloseAdminAccessModal();
      navigate(MOVIES_ADMIN_ROUTE);
    } catch (_error) {
      setAdminAccessStatus('error');
      setAdminAccessMessage(getUnavailableApiMessage());
    }
  };

  return {
    isAdminAccessModalOpen,
    adminSecret,
    setAdminSecret,
    adminAccessStatus,
    adminAccessMessage,
    handleOpenAdminAccessModal,
    handleCloseAdminAccessModal,
    handleAdminAccessSubmit,
  };
};
